export var CREATE_WALLET_USDT = 'CREATE_WALLET_USDT';
export var SUCCESS_CREATE_WALLET_USDT = 'SUCCESS_CREATE_WALLET_USDT';
export var FAILURE_CREATE_WALLET_USDT = 'FAILURE_CREATE_WALLET_USDT';
export var FETCH_STATUS_CREATED_USDT = 'FETCH_STATUS_CREATED_USDT';
export var SUCCESS_FETCH_STATUS_CREATED_USDT = 'SUCCESS_FETCH_STATUS_CREATED_USDT';
export var FAILURE_FETCH_STATUS_CREATED_USDT = 'FAILURE_FETCH_STATUS_CREATED_USDT';
export var CLEAR_USDT_STATE = 'CLEAR_USDT_STATE';



// WEBPACK FOOTER //
// ./src/actions/recharge/usdt.js